import App from '@modules/husleie-framework/src/static-classes/App.class';
import LogOperations from '@modules/husleie-framework/src/static-classes/LogOperations.class';
import axios from 'axios';
import { set } from 'lodash';
import Raven from 'raven-js';
import I18nOperations from './utils/I18nOperations.class';

const formatData = terms => {
  const transObj = {};
  terms.forEach(term => {
    const objPath = term.context.replace(/"/g, '').split('.');
    objPath.push(term.term);
    const trans = term.definition && term.definition.length ? term.definition.replace(/"/g, '') : term.term;
    set(transObj, objPath, trans);
  });
  return transObj;
};

const loadFromFile = (projectName, locale) => {
  return new Promise((resolve, reject) => {
    return import(/* webpackChunkName: "lang-[request]" */ `@/locales/${locale}.json`)
      .then(messages => {
        resolve(formatData(messages.default));
      })
      .catch(err => {
        const warningMessage =
          'Local translations ' +
          ` (environment '${App.getEnvironment()}'` +
          `, app '${App.getName()}'` +
          `, project '${App.getTranslationsDefaultProject()}'` +
          `, error '${err}'`;
        Raven.captureMessage(warningMessage);
        reject(err);
      });
  });
};

const loadFromAPI = (projectName, locale) => {
  return new Promise((resolve, reject) => {
    const url = `${App.getTranslationsAPIBaseUrl()}/translations?projects=${App.getTranslationsDefaultProject()}&languageCode=${locale}`;
    return axios
      .get(url)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        const warningMessage =
          'API translations ' +
          ` (environment '${App.getEnvironment()}'` +
          `, app '${App.getName()}'` +
          `, project '${App.getTranslationsDefaultProject()}'` +
          `, error '${err}'`;
        Raven.captureMessage(warningMessage);
        reject(err);
      });
  });
};

export async function fetchTranslationMessages(projectName, locale, origin) {
  const ietfLocale = I18nOperations.getIETFLocale(locale);

  let translations = {};
  switch (origin) {
    case 'local':
      try {
        translations = await loadFromFile(projectName, locale);
      } catch (errorLocal) {
        LogOperations.warning('i18n', errorLocal);
        translations = {};
        // continue without translations, using the terms only
      }
      break;
    case 'api':
    default:
      try {
        translations = await loadFromAPI(projectName, ietfLocale);
      } catch (errorApi) {
        translations = await fetchTranslationMessages(projectName, locale, 'local');
      }
  }

  LogOperations.debug('i18n|locale - origin', locale, origin);

  return translations;
}
